// Types
interface QuizData {
  fullName: string
  age: number
  birthDate?: string
  step: string
  utms: {
    [key: string]: string
  }
  userId?: string
  completed?: boolean
  checkout?: boolean
}

// Generate UUID v4
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

// Get or create user ID
const getUserId = (): string => {
  let userId = localStorage.getItem('quiz_user_id')
  if (!userId) {
    userId = generateUUID()
    localStorage.setItem('quiz_user_id', userId)

    // Initialize UTM parameters with new userId
    const currentUrl = new URL(window.location.href)
    const params = new URLSearchParams(currentUrl.search)
    if (!params.has('utm_id')) {
      params.set('utm_id', userId)
      const newUrl = `${window.location.pathname}?${params.toString()}`
      window.history.replaceState({}, '', newUrl)
    }
  }
  return userId
}

export const sendQuizData = async (data: QuizData) => {
  // Only send data if we have both name and age
  if (!data.fullName || !data.age) {
    return null
  }

  try {
    const userId = getUserId()

    const response = await fetch('https://send.thoththesage.com/webhook/dark/quiz/data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        userId,
        completed: data.step === 'quiz_18' // Final step
      })
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.error('Error sending quiz data:', error)
    return null
  }
}

export const trackCheckout = async () => {
  try {
    const userId = getUserId()
    const birthDate = localStorage.getItem('quiz_birthdate')

    await sendQuizData({
      fullName: localStorage.getItem('quiz_name') || '',
      age: parseInt(localStorage.getItem('quiz_age') || '0'),
      birthDate: birthDate || undefined,
      step: 'checkout',
      utms: getUtmParams(),
      userId,
      checkout: true
    })
  } catch (error) {
    console.error('Error tracking checkout:', error)
  }
}

export const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const utmParams: { [key: string]: string } = {}

  // Capture all UTM parameters dynamically
  for (const [key, value] of urlParams.entries()) {
    if (key.toLowerCase().startsWith('utm_')) {
      utmParams[key] = value
    }
  }

  // Ensure utm_id is always included if available
  const userId = localStorage.getItem('quiz_user_id')
  if (userId && !utmParams['utm_id']) {
    utmParams['utm_id'] = userId
  }

  return utmParams
}